import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import PublicHeader from "@/components/PublicHeader";

/**
 * Landing page after the customer cancels Stripe Checkout. The backend
 * webhook or the 15-minute expiry sweep will release the listing back to
 * `live` shortly — we don't need to do anything here except explain what
 * happened and offer a link back to search.
 */
export default function ReservationPaymentCancel() {
  return (
    <>
      <PublicHeader />
      <main className="min-h-screen" data-testid="reservation-payment-cancel">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16 text-center">
          <XCircle className="w-10 h-10 text-slate-500 mx-auto" />
          <h1 className="font-display font-bold text-2xl text-slate-900 mt-4">
            Payment cancelled
          </h1>
          <p className="text-slate-600 mt-2 text-sm">
            No charge was made. The remnant has been released back to the
            marketplace — you can reserve again any time.
          </p>
          <Link
            to="/search"
            className="fm-btn-primary inline-block mt-6"
            data-testid="back-to-search"
          >
            Back to search
          </Link>
        </div>
      </main>
    </>
  );
}
